import { render, staticRenderFns } from "./SegundaViaBoleto.vue?vue&type=template&id=be4ba51c&scoped=true"
import script from "./SegundaViaBoleto.vue?vue&type=script&lang=js"
export * from "./SegundaViaBoleto.vue?vue&type=script&lang=js"
import style0 from "./SegundaViaBoleto.vue?vue&type=style&index=0&id=be4ba51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ba51c",
  null
  
)

export default component.exports